import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import {TOGGLE_MENU_VISIBILITY} from '../state/uiActions'

import { faToggleOff, faToggleOn, faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/**
 * The menu button overlay over the map to open the left side menu column. 
 * 
 * Hidden when the menu is open. 
 **/ 
 export default function MenuToggleOverlayContainer(props) {

  const dispatch = useDispatch(); 
  const menuVisible = useSelector((state) => state.ui.menuVisible)

  const handleClick = () => {
    dispatch({ type: TOGGLE_MENU_VISIBILITY })
  }  

  if (! menuVisible || true) { // HACK: don't hide menu button
    var menuText = 'menu'
    if ((typeof MENU_BUTTON_TEXT !== "undefined") ) menuText = MENU_BUTTON_TEXT
    return (
      <div id="menuToggleOverlay"  style={{paddingRight: "4px"}}>
        <div className="rounded">
          <button type="button" className="btn btn-block text-left ml-0 menuSwitcher"
                  onClick={() => handleClick()}>
            <FontAwesomeIcon icon={faBars} /> &nbsp;&nbsp; {menuText}
          </button>
        </div>
      </div>
    )
  }
  else return null ;
}

//const mapStateToProps = (state) => {
//  return {
//    menuVisible: state.ui.menuVisible,
//  }
//}

//const mapDispatchToProps = (dispatch) => {
//  return {
//    toggleMenuVisibility: () => {
//      // show menu sidebar 
//      document.getElementById("sidebar").classList.remove("d-none");
//      // scroll up to make menu visible when turned on (important on mobile)
//      // TODO: scrollby might be used? 
//      // when in iframe, scrolls in the whole page to the iframe? 
//      // window.scrollTo(0, 0); 
//      // dispatch change event
//      dispatch({ type: TOGGLE_MENU_VISIBILITY }) ;
//      // have to dispatch resize event for the map to be resized correctly
//      window.dispatchEvent(new Event('resize'));
//    }
//  }
//}
//
//export default connect(
//  mapStateToProps, mapDispatchToProps
//)(MenuToggleOverlayContainer);